// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mailing-list__header {
    margin: 1.5rem 4rem;
    display: flex;
    justify-content: space-between;
}

.mailing-list {
    height: calc(100vh - 6rem);
    overflow: auto;
    position: relative;
}

.mailing-list__table {
    min-width: 60rem;
}

.mailing-list thead th {
    text-align: center;
}

.mailing-list__table tbody td {
    text-align: center !important;
} 

.mailing-list__mailing-id-block {
    width: 2rem;
}

.mailing-list__buttons-block {
    display: flex;
    justify-content: flex-end;
    flex-wrap: nowrap;
    column-gap: 1rem;
}

.mailing-list__buttons-block button {
    word-break: initial;
}

.mailing-list__mailing_delete_button {
    background-color: #d22e37;
}

.mailing-list__mailing_edit_button {
    background-color: #1696a6;
}

.mailing-list__mailing_start_button {
}

.mailing-list_id {
    min-width: 8rem;
    color: #ccc;
    font-size: 1.6rem;
}

.mailing-list_name {
    min-width: 30rem;
    max-width: 30rem;
}

.mailing-list__created-date {
    min-width: 12rem;
}`, "",{"version":3,"sources":["webpack://./src/app/mailing/mailing-main/mailing-list/MailingList.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;AACA;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".mailing-list__header {\r\n    margin: 1.5rem 4rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.mailing-list {\r\n    height: calc(100vh - 6rem);\r\n    overflow: auto;\r\n    position: relative;\r\n}\r\n\r\n.mailing-list__table {\r\n    min-width: 60rem;\r\n}\r\n\r\n.mailing-list thead th {\r\n    text-align: center;\r\n}\r\n\r\n.mailing-list__table tbody td {\r\n    text-align: center !important;\r\n} \r\n\r\n.mailing-list__mailing-id-block {\r\n    width: 2rem;\r\n}\r\n\r\n.mailing-list__buttons-block {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    flex-wrap: nowrap;\r\n    column-gap: 1rem;\r\n}\r\n\r\n.mailing-list__buttons-block button {\r\n    word-break: initial;\r\n}\r\n\r\n.mailing-list__mailing_delete_button {\r\n    background-color: #d22e37;\r\n}\r\n\r\n.mailing-list__mailing_edit_button {\r\n    background-color: #1696a6;\r\n}\r\n\r\n.mailing-list__mailing_start_button {\r\n}\r\n\r\n.mailing-list_id {\r\n    min-width: 8rem;\r\n    color: #ccc;\r\n    font-size: 1.6rem;\r\n}\r\n\r\n.mailing-list_name {\r\n    min-width: 30rem;\r\n    max-width: 30rem;\r\n}\r\n\r\n.mailing-list__created-date {\r\n    min-width: 12rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
